import React from "react";
import { t } from "utils/text.js";

export default function Footer() {
    return (
        <>
            <footer className="relative">
                <div className="container mx-auto">
                    <div className="flex flex-wrap text-center md:text-left">
                        <div className="w-full md:w-6/12">
                            <h4 className="font-semibold">{t("follow")} APENFT.IO</h4>
                            <h5 className="text-left">{t("footer_h5")}</h5>
                        </div>
                        <div className="w-full md:w-6/12">
                            <div className="flex flex-wrap">
                                <div className="w-full md:w-8/12 mx-auto">
                                    <h4 className="font-semibold">{t("contact_us")}</h4>
                                    <ul className="list-unstyled overflow-hidden">
                                        <li>
                                            <a
                                                className="flex items-center"
                                                href="mailto:contact@apenft.io"
                                                target="_blank"
                                                rel="noreferrer">
                                                <i className="fas fa-envelope"></i>{" "}
                                                <span>contact@apenft.io</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="flex items-center"
                                                href="https://t.me/apenftEN"
                                                target="_blank"
                                                rel="noreferrer">
                                                <i className="fab fa-telegram"></i> https://t.me/apenftEN
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="flex items-center"
                                                href="https://twitter.com/apenftorg"
                                                target="_blank"
                                                rel="noreferrer">
                                                <i className="fab fa-twitter"></i>{" "}
                                                https://twitter.com/apenftorg
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="flex items-center"
                                                href="https://apenftorg.medium.com/"
                                                target="_blank"
                                                rel="noreferrer">
                                                <i className="fab fa-medium"></i> https://apenftorg.medium.com
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="flex items-center"
                                                href="https://discord.com/invite/SgrbAYKWKk"
                                                target="_blank"
                                                rel="noreferrer">
                                                <i className="fab fa-discord"></i>{" "}
                                                https://discord.com/invite/SgrbAYKWKk
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="w-full mx-auto tail">
                        <div className="font-semibold">
                            <img
                                className="inline mr-6"
                                src={require("../../assets/img/logo_gray.png").default}
                            />
                        </div>
                        <div>{t("footer_tail")}</div>
                    </div>
                </div>
            </footer>
        </>
    );
}
